<template>
  <v-container id="facturap-alta" fluid>
    <validation-observer v-slot="{ handleSubmit }">
      <form id="form-facturaproveedor" @submit.prevent="handleSubmit(validateForm)">
        <v-row justify="center">
          <v-col cols="12" md="10">
            <base-material-card color="gold" inline icon="mdi-account-box" :title="tittle" class="px-5 py-3">
              <template v-slot:after-title>
                <v-btn v-if="mode !== 'show'" :disabled="$disabled()" color="gold" class="mr-0" type="submit" form="form-facturaproveedor">
                  Guardar
                </v-btn>
              </template>
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="contacto" rules="required">
                      <v-select v-model="dataForm.contacto_id" color="gold" :error-messages="errors" label="Contacto" item-value="id" :item-text="item =>`${item.nombre}`" :items="contactos">
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="contactoText(item)" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template v-slot:append-outer>
                          <v-btn elevation="1" color="success" fab x-small @click="agregarNuevoContacto">
                            <v-icon>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu ref="menuFecha" v-model="menuFecha" :close-on-content-click="false" transition="scale-transition" min-width="290px" :disabled="mode === 'show'" offset-y>
                      <template v-slot:activator="{ on }">
                        <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                          <v-text-field v-model="dataForm.fecha" color="gold" :error-messages="errors" label="Fecha" readonly v-on="on" />
                        </validation-provider>
                      </template>
                      <v-date-picker v-model="dataForm.fecha" color="gold" no-title landscape scrollable locale="es-419" @input="menuFecha = false" />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu ref="menuFechaVencimiento" v-model="menuFechaVencimiento" :close-on-content-click="false" transition="scale-transition" min-width="290px" :disabled="mode === 'show'" offset-y>
                      <template v-slot:activator="{ on }">
                        <validation-provider v-slot="{ errors }" name="Fecha vencimiento" rules="required">
                          <v-text-field v-model="dataForm.fecha_vencimiento" color="gold" :error-messages="errors" label="Fecha vencimiento" readonly v-on="on" />
                        </validation-provider>
                      </template>
                      <v-date-picker v-model="dataForm.fecha_vencimiento" color="gold" no-title landscape scrollable locale="es-419" @input="menuFechaVencimiento = false" />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="numero" rules="required|max:45">
                      <v-text-field v-model="dataForm.numero" color="gold" :error-messages="errors" label="Número factura" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="moneda" rules="required">
                      <v-select v-model="dataForm.moneda_id" :items="monedas" label="Moneda" :error-messages="errors" item-value="id" item-text="descripcion" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6" class="pt-1 pb-1">
                    <base-upload-files folder="/documentaciones/facturas-proveedor" :documento-id="dataForm.documentacion" tipo="pdf" @documento="dataForm.documentacion = $event" />
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider v-slot="{ errors }" name="Monto" rules="required|max:30">
                      <v-text-field v-model="dataForm.monto" color="gold" :error-messages="errors" label="Monto" step="0.01" type="number" @change="calcularTotal" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider v-slot="{ errors }" name="Impuestos" rules="required|max:30">
                      <v-text-field v-model="dataForm.impuestos" color="gold" :error-messages="errors" label="Impuestos" step="0.01" type="number" @change="calcularTotal" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider v-slot="{ errors }" name="Percepciones" rules="required|max:30">
                      <v-text-field v-model="dataForm.percepciones" color="gold" :error-messages="errors" label="Percepciones" step="0.01" type="number" @change="calcularTotal" />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" class="pt-1 pb-1">
                    <validation-provider v-slot="{ errors }" name="descripcion" rules="max:250">
                      <v-textarea v-model="dataForm.descripcion" :error-messages="errors" color="gold" name="input-6-1" rows="4" label="Descripción" :readonly="mode === 'show'" />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-col cols="12" md="3">
                    <v-text-field v-model="dataForm.total" color="gold" label="Total" type="number" readonly />
                  </v-col>
                </v-row>
              </v-container>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <contactos-form :show="mostrarContactoForm" @update="getContactos" />
  </v-container>
</template>

<script>
  import ContactosForm from '../altas/ContactosForm'

  export default {
    name: 'AltaFacturaP',
    components: {
      ContactosForm,
    },
    props: {
      mode: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        tittle: 'Nueva factura',
        menuFecha: false,
        menuFechaVencimiento: false,
        mostrarContactoForm: false,
        contactos: [],
        monedas: [],
        dataForm: {
          contacto_id: null,
          fecha: null,
          fecha_vencimiento: null,
          documentacion: null,
          monto: 0,
          impuestos: 0,
          percepciones: 0,
          total: 0,
        },
      }
    },
    computed: {

    },
    created () {
      this.setTittle()
      this.getContactos()
      this.getMonedas()
    },
    methods: {
      calcularTotal () {
        this.dataForm.total = (parseFloat(this.dataForm.monto) + parseFloat(this.dataForm.impuestos) + parseFloat(this.dataForm.percepciones)).toFixed(2)
      },
      agregarNuevoContacto () {
        this.mostrarContactoForm = true
      },
      contactoText (item) {
        const rs = item.razon_social
        if (rs !== null) {
          return item.nombre + ' - ' + rs
        }
        return item.nombre
      },
      getContactos: async function (idContacto) {
        this.mostrarContactoForm = false // esto no se hace XD
        this.$store.dispatch('axiosMod/getData', { url: '/api/contactos' }).then(response => {
          this.contactos = response
          if (idContacto !== 0) {
            this.dataForm.contacto_id = idContacto
          } else if (this.contactos.length !== 0) {
            this.dataForm.contacto_id = this.contactos[0].id
          }
        })
      },
      getMonedas () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },
      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nueva factura'
        } else if (this.mode === 'show') {
          this.tittle = 'Informacion factura'
        } else {
          this.tittle = 'Editar factura'
        }
      },
      validateForm (scope) {
        this.enviarFactura()
      },
      enviarFactura: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/factura-proveedor', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de factira exitosa'] })
          this.$router.push({ name: 'Facturas proveedores' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
        /* let method = ''
        let id = ''
        let message = ''
        if (this.mode === 'new') {
          method = 'post'
          message = ['Alta de factura exitosa']
        } else {
          method = 'put'
          message = ['Edición de factura exitosa']
          id = '/' + this.dataForm.id
        }
        await this.$http({
          method: method,
          url: '/api/factura-proveedor' + id,
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: message })
          this.$router.push({ name: 'Facturas proveedores' })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        }) */
      },
    },
  }
</script>
